<template>
  <footer>
    <div class="site-footer-top" role="contentinfo">
      <div class="container">
        <div v-if="isPwa" class="row pt-4">
          <div class="col-12 col-md-6">
            <h4 class="mb-2">{{ dictionary.forNewCustomers }}</h4>
            <h2>{{ dictionary.getDiscount }}</h2>
          </div>
          <div class="col-12 col-md-6 mt-2 site-footer-top-button-wrap">
            <button class="btn site-footer-top-button" @click="openRegistrationPopUp">
              {{ dictionary.wannaGetDiscount }}
            </button>
          </div>
        </div>

        <div class="row pb-3 pt-3 justify-content-between">
          <span
              v-for="(footerAdvantage, index) in footerAdvantages"
              :key="index"
              class="col-6 col-md-auto site-footer-top-link"
              tabindex="-1"
          >
            <div class="site-footer-top-wrap-img">
              <img :src="footerAdvantage.imageUrl"
                   :alt="footerAdvantage.imageUrl" class="site-footer-top-img"
                   loading="lazy"/>
            </div>

            <a
                v-if="lang === 'cz' || lang === 'sk'"
                :href="footerAdvantage.url"
                v-html="footerAdvantage.title"
                class="site-footer-top-text">
            </a>
            <!-- eslint-disable vue/no-v-html -->
            <div v-else v-html="footerAdvantage.title" class="site-footer-top-text"></div>
            <!--eslint-enable-->
          </span>
        </div>
      </div>
    </div>

    <div class="site-footer-bottom">
      <div class="container">
        <div class="footer-backtop" id="footer-backtop"
             @click="backToTop"></div>
        <div class="footer-main">
          <div v-if="lang !== 'cz'" class="footer-main__item row show">
            <h4 class="footer-main__title col-md-3 mb-sm-3">
              {{ dictionary.recomendedYou }}</h4>
            <div class="footer-main__content col-md-9">
              <div class="row">
                <div class="col-md-4 mb-md-3">
                  <a v-if="dictionary.customerSupport.phone.length > 0"
                      class="quick-contacts__title"
                     :href="`tel:${dictionary.customerSupport.phone}`">
                    <b>{{ dictionary.customerSupport.phoneName }} {{ dictionary.customerSupport.phone }}</b> <br/>
                  </a>
                  <a v-if="dictionary.customerSupport.whatsApp.length > 0" class="quick-contacts__title"
                     :href="`tel:${dictionary.customerSupport.whatsApp}`">
                    <b>{{ dictionary.customerSupport.whatsAppName }} {{ dictionary.customerSupport.whatsApp }}</b> <br/>
                  </a>
                  <span v-html="dictionary.customerSupport.phoneAvailability"></span>

                </div>
                <div class="col-6 col-md-4 mb-md-3">
                  <a class="quick-contacts__title"
                     v-if="dictionary.customerSupport.email.length > 0"
                     :href="`mailto:${dictionary.customerSupport.email}`">
                    <b>{{ dictionary.customerSupport.email }}</b> <br/>
                  </a>
                  <span
                      v-html="dictionary.customerSupport.emailAvailability"></span>

                </div>
                <div class="col-6 col-md-4 mb-md-3">

                  <span v-if="dictionary.customerSupport.chat.length > 0">
                    <a class="quick-contacts__title"
                       :href="dictionary.customerSupport.contact">
                      <b v-html="dictionary.customerSupport.chat"></b>
                    </a>
                    <span v-html="dictionary.customerSupport.chatAvailability"></span>
                  </span>

                  <span v-if="dictionary.customerSupport.address_street.length > 0" class="quick-contacts__title" :class="{'mt-3': dictionary.customerSupport.chat}">
                    <b>{{ dictionary.customerSupport.address_street }}</b><br/>
                  </span>
                  <span
                      v-html="dictionary.customerSupport.address"></span>
                </div>
              </div>
            </div>
            <hr />
          </div>

          <div v-for="(footerLinkSection, index) in footerLinkSections"
               :key="index" class="footer-main__item footer-accordion row"
               :class="index == 0 ? 'show' : ''"
               ref="footerAccordion"
          >
            <h4 class="footer-main__title col-md-3 mb-sm-3 mb-sm-0"
                @click="accordion($event,index)">
              {{ footerLinkSection.title }}
            </h4>
            <div class="footer-main__content col-md-9 d-sm-bock">
              <div class="col-9">
                <a
                    v-for="(footerLink, i) in footerLinkSection.links"
                    :key="i"
                    :href="footerLink.url"
                    class="footer-main__link"
                    :target="footerLink.isOutlink ? '_blank' : null"
                    :rel="footerLink.isOutlink ? 'noopener noreferrer' : null"
                >
                  {{ footerLink.title }}
                </a>
              </div>
              <div v-if="lang !== 'hu' && lang !== 'cz'">
                <span v-if="Object.keys(dictionary.sukl).length > 1 && Object.keys(footerLinkSections).length - 1 === index">
                  <a v-if="dictionary.sukl.footerSukl"
                     class="footer-sukl d-none d-sm-block"
                     :href="dictionary.sukl.footerSukl.url"
                     rel="noopener noreferrer"
                     target="_blank"
                     style="height: 100px"
                  >
                    <img :src="dictionary.sukl.footerSukl.imagePath" width="110" loading="lazy"
                         :alt="dictionary.sukl.footerSukl.alt"/>
                  </a>
                  <a v-if="dictionary.sukl.footerSukl1"
                      class="footer-sukl d-none d-sm-block"
                      :href="dictionary.sukl.footerSukl1.url"
                      rel="noopener noreferrer"
                      target="_blank"
                      style="height: 100px"
                  >
                    <img :src="dictionary.sukl.footerSukl1.imagePath" width="110" loading="lazy"
                         :alt="dictionary.sukl.footerSukl1.alt"/>
                  </a>
                  <a v-if="dictionary.sukl.footerUskvbl1"
                      class="footer-sukl d-none d-sm-block"
                      :href="dictionary.sukl.footerUskvbl1.url"
                      rel="noopener noreferrer"
                      target="_blank"
                      style="height: 100px"
                  >
                    <img :src="dictionary.sukl.footerUskvbl1.imagePath" width="110" loading="lazy"
                         :alt="dictionary.sukl.footerUskvbl1.alt"/>
                  </a>
                  <a v-if="dictionary.sukl.footerUskvbl"
                      class="footer-sukl d-none d-sm-block"
                      :href="dictionary.sukl.footerUskvbl.url"
                      rel="noopener noreferrer"
                      target="_blank"
                      style="height: 100px"
                  >
                    <img :src="dictionary.sukl.footerUskvbl.imagePath" width="110" loading="lazy"
                         :alt="dictionary.sukl.footerUskvbl.alt"/>
                  </a>
                </span>
              </div>


                <a v-if="((lang === 'sk') || (lang === 'at')) && index === 2" class="footer-sukl d-none d-sm-block mt-4"
                   :href="dictionary.sukl.footerSukl.url"
                   rel="noopener noreferrer" target="_blank">
                  <img :src="dictionary.sukl.footerSukl.imagePath" loading="lazy"
                       :alt="dictionary.sukl.footerSukl.alt" width="110" />
                </a>

            </div>
            <hr />
          </div>

          <div class="footer-icons footer-main__item">
            <div class="footer-social row">
              <span class="footer-social__title d-sm-none">{{dictionary.downloadApp }}</span>
              <div class="col-12 col-md-6 text-center android-only desktop-only" v-if="dictionary.android.link !== 'footer.android.link'"
                   id="js-mobile-app-android-footer">
                <a
                    class="mobile-app__get-app mobile-app__get-app--footer google-play"
                    :class="`google-play-${lang}`"
                    :href="dictionary.android.link"
                    :title="dictionary.android.alt"
                    target="_blank"
                >
                  <img :src="`/nuxt-assets/images/icons/mobile/android/${lang}.svg`" :alt="dictionary.android.alt" loading="lazy" />
                </a>
              </div>

              <div class="col-12 col-md-6 text-center ios-only desktop-only" v-if="dictionary.ios.link !== 'footer.ios.link'"
                   id="js-mobile-app-ios-footer">
                <a class="mobile-app__get-app mobile-app__get-app--footer app-store"
                   :class="`app-store-${lang}`"
                   :href="dictionary.ios.link"
                   :title="dictionary.ios.alt"
                   target="_blank"
                >
                  <img :src="`/nuxt-assets/images/icons/mobile/apple/${lang}.svg`" :alt="dictionary.ios.alt" loading="lazy" />
                </a>
              </div>
            </div>

            <a v-if="lang === 'sk'" class="footer-sukl d-sm-none mt-4"
               :href="dictionary.sukl.footerSukl.url"
               rel="noopener noreferrer" target="_blank">
              <img :src="dictionary.sukl.footerSukl.imagePath" loading="lazy"
                   :alt="dictionary.sukl.footerSukl.alt" width="110" />
            </a>

            <div class="flags">
              <span v-for="footerFlag in footerFlags" :key="footerFlag.id">
                <a :href="footerFlag.url"
                   class="item col-auto" target="_blank">
                  <img :src="`/nuxt-assets/images/flags/${footerFlag.code}.svg`"
                       alt="footerFlag" width="28" class="opacity-50"
                       loading="lazy"/>
                </a>
              </span>
            </div>

            <div class="social-links">
              <a
                  v-for="(footerSocial, index) in footerSocials"
                  :key="index"
                  :href="footerSocial.link"
                  class="hover-tdn"
                  target="_blank"
                  tabindex="-1"
                  :title="footerSocial.title"
              >
                <i class="ico hover-filter-grayscale"
                   :class="footerSocial.icoCssClass"></i>
              </a>
            </div>

          </div>
          <hr class="full" />

          <ListPayMethods v-if="listPayMethods && listPayMethods.length > 0" :listPayMethods="listPayMethods" />

          <div v-if="lang === 'ro'" class="row flex-sm-row-reverse mb-3 footer-main__item border-0 align-items-center">
            <div class="col-12 col-md-5 d-flex justify-content-around align-content-center mb-4 mb-sm-0 align-items-center">
              <a v-if="dictionary.sukl.footerSukl"
                  class="footer-sukl"
                  :href="dictionary.sukl.footerSukl.url"
                  rel="noopener noreferrer"
                  target="_blank"
              >
                <img :src="dictionary.sukl.footerSukl.imagePath" width="110" height="92" loading="lazy"
                     :alt="dictionary.sukl.footerSukl.alt"/>
              </a>
              <a
                  :href="`${footerTrustedImage.url}`"
                  target="_blank"
                  :title="`${footerTrustedImage.alt}`"
                  rel="noreferrer"
              >
                <img :src="`${footerTrustedImage.imagePath}`" width="83" height="97" loading="lazy"
                     :alt="`${footerTrustedImage.alt}`" />
              </a>

            </div>
            <div class="col-12 col-md-7 d-sm-flex justify-content-center justify-content-sm-around align-content-center text-center gap-2 align-items-center">
              <a
                  :href="`${footerAnpcImage.url}`"
                  target="_blank"
                  :title="`${footerAnpcImage.alt}`"
                  rel="noreferrer"
                  class="mb-4 mb-sm-0 d-inline-block"
              >
                <img :src="`${footerAnpcImage.imagePath}`" height="64" loading="lazy"
                     :alt="`${footerAnpcImage.alt}`" />
              </a>
              <a
                  :href="`${footerEuropaImage.url}`"
                  target="_blank"
                  :title="`${footerEuropaImage.alt}`"
                  rel="noreferrer"
                  class="d-inline-block"
              >
                <img :src="`${footerEuropaImage.imagePath}`" height="64" loading="lazy"
                     :alt="`${footerEuropaImage.alt}`" />
              </a>
            </div>
          </div>

          <div v-if="lang === 'cz' && Object.keys(dictionary.sukl).length > 1" class="suklDown">
                  <a v-if="dictionary.sukl.footerSukl"
                     class="footer-sukl"
                     :href="dictionary.sukl.footerSukl.url"
                     rel="noopener noreferrer"
                     target="_blank"
                  >
                    <img :src="dictionary.sukl.footerSukl.imagePath" width="110" loading="lazy"
                         :alt="dictionary.sukl.footerSukl.alt"/>
                  </a>
                  <a v-if="dictionary.sukl.footerSukl1"
                     class="footer-sukl"
                     :href="dictionary.sukl.footerSukl1.url"
                     rel="noopener noreferrer"
                     target="_blank"
                  >
                    <img :src="dictionary.sukl.footerSukl1.imagePath" width="110" loading="lazy"
                         :alt="dictionary.sukl.footerSukl1.alt"/>
                  </a>
                  <a v-if="dictionary.sukl.footerUskvbl1"
                     class="footer-sukl"
                     :href="dictionary.sukl.footerUskvbl1.url"
                     rel="noopener noreferrer"
                     target="_blank"
                  >
                    <img :src="dictionary.sukl.footerUskvbl1.imagePath" width="110" loading="lazy"
                         :alt="dictionary.sukl.footerUskvbl1.alt"/>
                  </a>
                  <a v-if="dictionary.sukl.footerUskvbl"
                     class="footer-sukl"
                     :href="dictionary.sukl.footerUskvbl.url"
                     rel="noopener noreferrer"
                     target="_blank"
                  >
                    <img :src="dictionary.sukl.footerUskvbl.imagePath" width="110" loading="lazy"
                         :alt="dictionary.sukl.footerUskvbl.alt"/>
                  </a>
          </div>
        </div>
        <!-- <Cookiebar />-->

        <div class="footer__bottom">
          <div v-if="lang === 'hu'" class="d-flex align-items-center justify-content-center pt-3 pb-4">
            <img :src="`nuxt-assets/footer/arukereso-trusted-shop.png`" width="100" height="100" alt="Arukereso" loading="lazy" />
          </div>
          <div v-if="lang === 'at'" class="d-flex align-items-center justify-content-center pt-3 pb-4 mx-5">
            <img :src="`nuxt-assets/footer/geizhals.svg`" width="150" height="87" alt="Geizhals" loading="lazy" />
          </div>
          <div v-if="lang === 'at'" class="d-flex align-items-center justify-content-center pt-3 pb-4 mx-2">
            <img :src="`nuxt-assets/footer/trusted_at2.png`" width="100" height="100" alt="Idealo" loading="lazy" />
          </div>
          <div v-if="lang === 'sk'" class="d-flex align-items-center justify-content-center pt-3 pb-4 mx-2">
            <img :src="`nuxt-assets/footer/superbrands-sk.png`" width="112" height="110" alt="Superbrands" loading="lazy" />
          </div>

          <RatingShop :dictionary="dictionary" />

        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import RatingShop from "./RatingShop";
import ListPayMethods from "./ListPayMethods";

export default {
  components: {
    RatingShop,
    ListPayMethods,
  },

  props: {
    lang: {
      type: String,
      default: "",
    },
    structuredData: {
      type: Object,
      default: null,
    },
    dictionary: {
      type: Object,
      required: true,
    },
    listPayMethods: {
      type: Array,
      required: false
    },
    isPwa: {
      type: Boolean,
      required: false,
      default: false
    },
  },

  data() {
    return {
      footerAdvantages: this.dictionary.advantages,
      footerLinkSections: this.dictionary.linkSections,
      footerSocials: this.dictionary.socials,
      footerFlags: this.dictionary.flags,

      footerTrustedImage: {
        url: "https://www.trusted.ro/assets/verify.php?id=3f74a886c7f841699690962c497d4f30",
        imagePath: "/nuxt-assets/footer/trusted_ro.png",
        alt: "Trusted.ro",
      },
      footerAnpcImage: {
        url: "https://anpc.ro/ce-este-sal",
        imagePath: "/nuxt-assets/footer/anpc_ro.svg",
        alt: "anpc.ro",
      },
      footerEuropaImage: {
        url: "http://ec.europa.eu/consumers/odr",
        imagePath: "/nuxt-assets/footer/europa_ro.svg",
        alt: "europa.eu",
      },
      isOpen: false,
    };
  },

  methods: {

    backToTop() {
      window.scrollTo({top: 0, behavior: "smooth"});
    },

    accordion(event,index) {
      const element = this.$refs.footerAccordion
      const actualElement = element[index]
      const actualElementState = actualElement.classList.contains('show')

      if (actualElementState) {
        actualElement.classList.remove('show')
      } else {
        element.forEach((item) => {
          item.classList.remove('show');
        })
        actualElement.classList.add('show')
      }
    },

    openRegistrationPopUp() {
      this.$emit('openRegistrationPopUp')
    },
  },
};
</script>

<style lang="scss">
$primary: #e6007eff;

.footer__bottom {
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  justify-content: center;
  flex-wrap: wrap;
  background: none;
}


.site-footer-top {
  background-color: #FFF4F2;
  color: #333333;
  font-size: 12px;

  @media only screen and (min-width: 576px) {
    font-size: 14px;
  }
}

.site-footer-top .container {
  max-width: 1320px;
}

.site-footer-top-link {
  color: #333333;
  font-weight: 700;
  text-decoration: none;
  font-size: 14px;
  line-height: 20px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}

.site-footer-top-button-wrap {
  @media (max-width: 768px) {
    text-align: center;
  }
}

.site-footer-top-button {
  background: #FFF4F2;
  border: 1px solid #e6007e;
  border-radius: 100px;
  color: #e6007e;
  display: inline-block;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 60px;
  text-align: center;

  &:hover {
    background: #e6007e;
    color: #fff;
  }
}

.site-footer-top-text {
  font-size: 10px;
  line-height: 13px;

  @media only screen and (min-width: 980px) {
    font-size: 14px;
    line-height: 16px;
  }
}

a.site-footer-top-text {
  color: #333333;
  text-decoration: none;

  &:hover {
    color: $primary;
  }
}

.site-footer-top-wrap-img {
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #FFFFFF;
  border-radius: 50px;
  flex: 0 0 30px;

  @media only screen and (min-width: 980px) {
    width: 46px;
    height: 46px;
    flex: 0 0 46px;
  }
}

.site-footer-top-img {
  max-width: 16px;
  width: auto;
  max-height: 16px;
  height: auto;

  @media only screen and (min-width: 980px) {
    max-width: 24px;
    max-height: 24px;
  }
}
.site-footer-bottom {
  font-size: 14px;
  max-width: 1570px;

  .container {
    position: relative;
    max-width: 1320px;
  }

  a.quick-contacts__title:hover {
    @media (min-width: 992px) {
      color: $primary;
    }
  }

  .quick-contacts {
    font-size: 13px;

    &__title {
      font-size: 14px;
      display: block;
      color: #333333;
      text-decoration: none;
      margin-bottom: 0.75em;
    }

    &__ico {
      text-align: center;
      width: 42px;
    }
  }
}

.footer-backtop {
  opacity: 1;
  position: absolute;
  z-index: 2;
  cursor: pointer;
  top: 3em;
  right: 10px;
  width: 30px;
  height: 30px;
  display: inline-block;
  background: url("https://www.pilulka.cz/nuxt-assets/images/icons/backtop.svg") center center / contain no-repeat;

  @media (min-width: 1350px) {
    right: -30px;
    top: 3em;
  }

  &:hover {
    background-image: url("https://www.pilulka.cz/nuxt-assets/images/icons/backtop-hover.svg");
    transition: 150ms ease-in-out;
  }
}

.flags {
  display: inline-block;

  .item {
    opacity: 0.5;
    margin: 0 0.5em;
    transition: 150ms ease-in-out;

    @media (max-width: 768px) {
      margin: 0 1em;
    }

    &:hover {
      opacity: 1;
      transition: 150ms ease-in-out;
    }
  }
}

.footer-social {
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;

  @media (min-width: 768px) {
    min-width: 290px;
  }

  &__title {
    flex: 100%;
    text-align: center;
    padding: 0.5em 0;
    font-weight: 500;
  }

  @media (max-width: 768px) {
    img {
      width: 185px;
    }
  }
}

.footer-icons {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 15px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 30px;
    padding-top: 15px;
  }

  @media (max-width: 768px) {
    > * {
      order: 99;
    }
    .social-links {
      order: 1;
      justify-content: center;
      padding: 0 10%;
      width: 100%;
    }
  }
}

.footer-main {
  padding-top: 1em;

  &__title {
    font-size: 18px;
    margin-bottom: 0;
    cursor: auto !important;
    font-weight: 500;

    @media (max-width: 768px) {
      font-size: 1rem;
      padding-top: 1em;
      padding-bottom: 1em;
    }
  }

  &__item {
    position: relative;
    @media (min-width: 768px) {
      padding: 2em 0 0 0;
    }
  }

  &__link {
    display: inline-block;
    width: 100%;
    color: #333333;
    line-height: 18px;
    font-size: 14px;
    padding: 7px 0;
    text-decoration: none;
    transition: 150ms ease-in-out;

    &:hover {
      transition: 150ms ease-in-out;
    }
  }

  @media (max-width: 768px) {
    &__content {
      transition: 200ms ease-in;
      padding-bottom: 1em;
    }

    &__item {
      &.show .footer-main__content {
        transition: 200ms ease-out;
        display: block;
      }
      .footer-main__content {
        display: none;
        transition: 200ms ease-out;
      }
    }
  }

  &__item.footer-accordion {
    @media (max-width: 768px) {
      &.show {
        .footer-main__title {
          &::after,
          &::after {
            content: "";
            display: block;
            width: 16px;
            height: 16px;
            position: absolute;
            top: 0;
            right: 15px;
            margin-top: 20px;
            border: solid black;
            border-width: 1px 1px 0 0;
            padding: 5px;
            transform: rotate(-45deg);
          }
        }
      }
      & .footer-main__title::after {
        content: "";
        display: block;
        width: 16px;
        height: 16px;
        position: absolute;
        right: 15px;
        margin-top: 20px;
        border: solid black;
        border-width: 1px 1px 0 0;
        padding: 5px;
        transform: rotate(135deg);
        transition: 200ms ease-out;
        top: -5px;
      }
    }

    .footer-main__content {
      @media (min-width: 768px) {
        display: block !important;
        height: 100% !important;
        column-count: 3;
      }
    }
  }

  hr {
    width: calc(100% - var(--bs-gutter-x));
    height: 1px;
    background-color: #f0f0f0;
    border: 0;

    @media (min-width: 768px) {
      margin-top: 2em;
    }

    &.full {
      width: 100%;
    }
  }
}

.mobile-app__get-app {
  display: inline-block!important;
  overflow: hidden;
  position: relative;
  border-radius: 5px;
  border: 1px solid #333333;
  margin: 0 auto;
  width: auto!important;
  max-width: 100%!important;

  @media (min-width: 768px) {
    max-width: 132px!important;
    max-height: 39px!important;
  }

  span {
    display: inline-block;
  }

  @media (min-width: 768px) {
    &:hover {
      border-radius: 5px;
      background: #333;
      transition: all 0.2s linear;
      border: 1px solid #333;

      img {
        filter: invert(1);
      }
    }
  }
}
@media (min-width: 768px) {
  .mobile-app__get-app--footer svg {
    max-width: 130px;
    height: auto;
  }

  .footer-sukl {
      margin-right: 15px;
  }
}
.footer__cookie {
  color: #505050;
  font-size: 12px;
  padding: 1em 0;
}

.social-links {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 15px;
}

.suklDown {
  display: flex;
  gap: 36px;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin: 20px auto 0;
  padding-top: 15px;
}

.android-only, .desktop-only, .ios-only {
    display: none;
}

body.isDesktop .desktop-only,
body.isAndroid .android-only,
body.isIos .ios-only {
    display: block;
}

</style>
